export function initializeOrGetImg () {
  return document.createElement('img');
}

export function initializeOrGetCanvas () {
  return document.createElement('canvas');
}
